var angular = require('angular');
var _module = require('../module');
var TweenMax = require('gsap');
var Timeline = require('gsap/src/uncompressed/TimelineLite');

require('angular-animate');

_module.requires.push('ngAnimate');

/*
Used to animate the select balls and
square buttons on the homepage.
 */
_module.animation('.animate-options-full', [
    '$log',
    '$window',

    function homesearchAnimate($log, $window) {
        return {
            enter: function homesearchEnter(elem, done) {
                var timeline = new Timeline({ onComplete: done });
                var totalOptions = angular.element(document.getElementsByClassName('options')).find('a').length;

                timeline
                    .from(elem, .6, { autoAlpha: 0 })
                    .staggerFrom(
                        '.options a',
                        .25,
                        {
                            scale: 0
                        },
                        .15,
                        '-= .3'
                    )
                    .staggerTo(
                        '.options a',
                        .3,
                        {
                            scale: .9
                        },
                        .5,
                        '+= .2'
                    )
                    .staggerTo(
                        '.options a',
                        .3,
                        {
                            scale: 1
                        },
                        .5,
                        '-= ' + (.5 * (totalOptions - 1))
                    );

            },
            leave: function homesearchLeave(elem, done) {
                var timeline = new Timeline({ onComplete: done });
                timeline.to(elem, .25, { autoAlpha: 0 });
            }
        };
    }
]);

/*
Used to animate the select balls and
square buttons on the homepage.
 */
_module.animation('.animate-options', [
    '$log',
    '$window',

    function homesearchAnimate($log, $window) {
        return {
            enter: function homesearchEnterShort(elem, done) {
                var timeline = new Timeline({ onComplete: done });
                timeline
                    .from(elem, .6, { autoAlpha: 0 })
                    .staggerFrom(
                        '.options a',
                        .25,
                        {
                            scale: 0
                        },
                        .15,
                        '-= .3'
                    );

            },
            leave: function homesearchLeaveShort(elem, done) {
                var timeline = new Timeline({ onComplete: done });
                timeline.to(elem, .25, { autoAlpha: 0 });
            }
        };
    }
]);


/*
Used to fade in on enter and fade out on leave
 */
_module.animation('.fade', [
    '$log',

    function fadeAnimate($log) {
        return {
            enter: function fadeEnter(elem, done) {
                var timeline = new Timeline({ onComplete: done });
                timeline.from(elem, 1, { autoAlpha: 0 });
            },
            leave: function fadeLeave(elem, done) {
                var timeline = new Timeline({ onComplete: done });
                timeline.to(elem, .25, { autoAlpha: 0 });
            }
        };
    }
]);


/*
Used on the view listing page for the more features
*/
_module.animation('.rolldown', [
    '$log',

    function rolldownAnimate($log) {
        return {
            enter: function rolldownEnter(elem, done) {
                var timeline = new Timeline({ onComplete: done });
                timeline.from(elem, .5, { height: 0 });
            },
            leave: function rolldownLeave(elem, done) {
                var timeline = new Timeline({ onComplete: done });
                timeline.to(elem, .5, { height: 0 });
            }
        };
    }
]);
